import { NgIf,NgClass } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { AIRService } from '../../../services/air.service';

// Interface for the status mapping result
interface StatusMapping {
  status: string;
  cssClass: string;
}
@Component({
    selector: 'app-air-installed-save-tab',
    imports: [TableModule, DropdownModule, FormsModule, NgClass],
    templateUrl: './air-installed-save-tab.component.html',
    styleUrl: './air-installed-save-tab.component.scss'
})
export class AirInstalledSaveTabComponent {

  @Input() airAPIData: any = '';
  
  // Initialize with empty array - will be populated from API
  installedData: any[] = [];

  
  // Store original data for filtering
  private originalInstalledData: any[] = [];
  

  constructor(private router: Router, private airService: AIRService) {
  }

  

  ngOnChanges(changes: SimpleChanges): void {
    // This lifecycle hook is called whenever an input property changes
    if (changes['airAPIData']) {
      if (this.airAPIData) {
        this.processAirData();
      }
    }
  }

  /**
   * Processes the received API data for both table and dropdown
   */
  private processAirData(): void {
    
    // Process dropdown data first
    if (this.airAPIData && 
        this.airAPIData.airOverviewData && 
        this.airAPIData.airOverviewData.divisionDropDownInstalledList && 
        this.airAPIData.airOverviewData.divisionDropDownInstalledList.divisionInstalledNames) {
      
      const divisionData = this.airAPIData.airOverviewData.divisionDropDownInstalledList.divisionInstalledNames;
      
      if (Array.isArray(divisionData) && divisionData.length > 0) {
        // Transform the data to ensure it has the correct structure for PrimeNG dropdown
       
        

      }
    }
    
    // Process table data
    if (this.airAPIData && 
        this.airAPIData.airOverviewData && 
        this.airAPIData.airOverviewData.airAssignedToMeData && 
        this.airAPIData.airOverviewData.airAssignedToMeData.AIRAssignedToMeInstalled) {
      
      const tableData = this.airAPIData.airOverviewData.airAssignedToMeData.AIRAssignedToMeInstalled;
      
      if (Array.isArray(tableData)) {
        this.originalInstalledData = tableData;
        this.processTableData(tableData);
      }
    }
  }

   
  /**
   * Maps a TLR status code to a user-friendly status label and CSS class
   * @param statusCode The TLR status code (I, P, R, etc.)
   * @returns Object containing the formatted status and CSS class
   */
  mapStatusAndCssClass(statusCode: string): StatusMapping {
    const statusCode2 = statusCode || '';
    let status = '';
    let cssClass = '';
    
    if (statusCode2 === 'I') {
      status = 'Installed';
      cssClass = 'green';
    } else if (statusCode2 === 'P') {
      status = 'Pre Installation';
      cssClass = 'blue';
    } else if (statusCode2 === 'R') {
      status = 'Removed';
      cssClass = 'red';
    } else {
      // Default case
      status = statusCode2;
      cssClass = '';
    }
    
    return { status, cssClass };
  }
  
  
  // Process the table data from API response
  processTableData(data: any[]): void {
    
    if (Array.isArray(data) && data.length > 0) {
      // Map API data to the format needed for the table
      this.originalInstalledData = data;
      this.installedData = data.map((item: any) => {
        // Convert tlr_status values to user-friendly text
        const { status, cssClass } = this.mapStatusAndCssClass(item.tlr_status);

        return {
          division: item.division_name || '',
          section: item.section_name || '',
          tlr: item.tag_number || '',
          status: status,
          cssClass: cssClass // Add CSS class for styling
        };
      });
      
    } else {
      console.warn('Unable to process table data: data is empty or not an array');
    }
  }
  
  
  details(row: any){
    this.router.navigate(['/details-section', row.tlr]);
  }
  
  // airComplianceDetails(){
  //   this.router.navigate(['/air-compliance-details-section'])
  // }
  airComplianceDetails(tagNumber: any, actionType: any): void {
    // Store actionType in localStorage with consistent key name
    localStorage.setItem('air_compliance_action_type', actionType);
    // Navigate to the details component with just the tagNumber in the URL
    this.router.navigate(['/air-compliance-details-section', tagNumber]);
  }

}

